import React, { useState, useEffect } from 'react';
import { Search, X, Phone, Calendar, MapPin, User, Loader2, House, PhoneIcon } from 'lucide-react';
// import { Booking } from '../types/booking';
// import { BookingService } from '../services/bookingService';
import { getBookings, updatPhoneNumerKross } from '../../helper/backend_helper';

export default function BookingSearchModal({ isOpen, onClose, selectedChat }) {
  const [searchTerm, setSearchTerm] = useState('');
  const [bookings, setBookings] = useState([]);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [isConnecting, setIsConnecting] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [searchError, setSearchError] = useState(null);
  const [hasSearched, setHasSearched] = useState(false);

  let phone = selectedChat?.contactNo.split('@')[0];
  phone = `+${phone}`;
  // Debounced search effect
  useEffect(() => {
    if (!isOpen) return;

    const timeoutId = setTimeout(() => {
      handleSearch();
    }, 500);

    // return () => clearTimeout(timeoutId);
  }, [searchTerm, isOpen]);

  const handleSearch = async () => {
    if (!isOpen) return;

    setIsSearching(true);
    setSearchError(null);
    setHasSearched(true);

    try {
      //   const results = await BookingService.searchBookings(searchTerm);

      const data = {
        page: 1,
        limit: 100,
        search: searchTerm,
      };

      const response = await getBookings(data);
      setBookings(response.data.data);
    } catch (error) {
      setSearchError('Failed to search bookings. Please try again.');
      setBookings([]);
    } finally {
      setIsSearching(false);
    }
  };

  const handleConnect = async () => {
    console.log(selectedBooking);

    if (!selectedBooking || !phone.trim()) return;
    // +5521920414405
    setIsConnecting(true);
    try {
      const response = await updatPhoneNumerKross(selectedBooking, { phone, conversationId: selectedChat._id });
      console.log(response);
      setSelectedBooking(null);
      setPhoneNumber('');
      onClose();
    } catch (error) {
      console.error('Failed to connect:', error);
    } finally {
      setIsConnecting(false);
    }
  };

  const resetModal = () => {
    setSearchTerm('');
    setBookings([]);
    setSelectedBooking(null);
    setPhoneNumber('');
    setIsConnecting(false);
    setIsSearching(false);
    setSearchError(null);
    setHasSearched(false);
  };

  const handleClose = () => {
    resetModal();
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm transition-opacity" />

      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-xl max-h-[90vh] flex flex-col overflow-hidden animate-in fade-in zoom-in duration-200">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-100">
          <h2 className="text-2xl font-bold text-gray-900">Search Bookings</h2>
          <button onClick={handleClose} className="p-2 hover:bg-gray-100 rounded-full transition-colors">
            <X className="w-5 h-5 text-gray-500" />
          </button>
        </div>

        {/* Search Bar */}
        <div className="p-6 border-b border-gray-100">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
            <input
              type="text"
              placeholder="Search by guest name, BnB name..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-12 pr-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
            />
            {isSearching && (
              <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                <Loader2 className="w-5 h-5 text-blue-500 animate-spin" />
              </div>
            )}
          </div>
        </div>

        {/* Booking List */}
        <div className="flex-1 overflow-y-auto p-6">
          {isSearching ? (
            <div className="text-center py-12">
              <Loader2 className="w-8 h-8 text-blue-500 animate-spin mx-auto mb-4" />
              <h3 className="text-lg font-medium text-gray-900 mb-2">Searching bookings...</h3>
              <p className="text-gray-500">Please wait while we find your bookings</p>
            </div>
          ) : searchError ? (
            <div className="text-center py-12">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <X className="w-6 h-6 text-red-600" />
              </div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">Search Error</h3>
              <p className="text-gray-500 mb-4">{searchError}</p>
              <button
                onClick={handleSearch}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
              >
                Try Again
              </button>
            </div>
          ) : !hasSearched ? (
            <div className="text-center py-12">
              <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Search className="w-6 h-6 text-gray-400" />
              </div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">Start searching</h3>
              <p className="text-gray-500">Enter a search term to find bookings</p>
            </div>
          ) : bookings.length === 0 ? (
            <div className="text-center py-12">
              <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Search className="w-6 h-6 text-gray-400" />
              </div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">No bookings found</h3>
              <p className="text-gray-500">Try adjusting your search criteria</p>
            </div>
          ) : (
            <div className="space-y-4">
              {bookings.map((booking) => (
                <div
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
                      e.preventDefault(); // prevents page scrolling for Space
                      setSelectedBooking(booking._id);
                    }
                  }}
                  key={booking._id}
                  className={`p-5 border-2 rounded-xl cursor-pointer transition-all hover:shadow-md ${
                    selectedBooking === booking._id
                      ? 'border-blue-500 bg-blue-50 shadow-md'
                      : 'border-gray-200 hover:border-gray-300'
                  }`}
                  onClick={() => setSelectedBooking(booking._id)}
                >
                  <div className="flex items-start justify-between mb-3">
                    <div className="flex flex-col gap-1">
                      {/* <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                        <User className="w-5 h-5 text-blue-600" />
                      </div> */}
                      {/* <div> */}
                      <h3 className="font-semibold text-gray-900">{booking.guestName}</h3>
                      <div className="flex items-center space-x-1 text-gray-600">
                        <House className="w-4 h-4" />
                        <span className="text-sm">{booking.BnBShortName}</span>
                      </div>
                      <div className="flex items-center space-x-1 text-gray-600">
                        <PhoneIcon className="w-3 h-3" />
                        <span className="text-xs flex-shrink-0">{booking.phone}</span>
                      </div>
                      {/* </div> */}
                    </div>

                    {selectedBooking === booking._id && (
                      <div className="w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center">
                        <div className="w-2 h-2 bg-white rounded-full" />
                      </div>
                    )}
                  </div>

                  <div className="flex justify-between gap-4 text-sm">
                    <div className="flex items-center space-x-3 text-sm">
                      <Calendar className="w-4 h-4 text-green-600" />
                      <div>
                        <span className="text-gray-500">Check-in:</span>
                        <div className="font-medium text-gray-900">
                          {booking.checkInDate}, {booking.checkInTime}
                        </div>
                      </div>
                    </div>

                    <div className="flex items-center space-x-3 text-sm">
                      <Calendar className="w-4 h-4 text-red-600" />
                      <div>
                        <span className="text-gray-500">Check-out:</span>
                        <div className="font-medium text-gray-900">
                          {booking.checkOutDate}, {booking.checkOutTime}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Connect Section */}
        {selectedBooking && (
          <div className="border-t border-gray-100 p-6 bg-gray-50">
            <div className="flex items-center space-x-4">
              <div className="relative flex-1">
                <div>{selectedChat?.conversation_name || selectedChat?.contactNo}</div>
                <div className="text-sm text-gray-500">{phone}</div>
              </div>
              {/* <div className="relative flex-1"> */}
              {/* <Phone className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
                <input
                  type="tel"
                  placeholder="Enter phone number"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  className="w-full pl-12 pr-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
                /> */}
              {/* {phone} */}
              {/* </div> */}

              <button
                onClick={handleConnect}
                disabled={isConnecting}
                className="px-8 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center space-x-2"
              >
                {isConnecting ? (
                  <>
                    <Loader2 className="w-4 h-4 animate-spin" />
                    <span>Connecting...</span>
                  </>
                ) : (
                  <>
                    <Phone className="w-4 h-4" />
                    <span>Connect</span>
                  </>
                )}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
